import * as z from "zod";

export type ReturnShippingBillSummary = z.infer<
  typeof returnShippingBillSummary
>;
export const returnShippingBillSummary = z.object({
  periodEnd: z.date(),
  totalAmount: z.number(),
});

export const getCurrentReturnShippingBill = {
  name: "getCurrentReturnShippingBill" as const,
  input: z.null(),
  output: returnShippingBillSummary.nullable(),
};
